import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { Popup } from 'src/components/Popup/Popup';
import { MarketSettingsForm } from 'src/domains/sportsbook/trading/view/eventDetails/markets/MarketSettingsForm';
import { action, observable, makeAutoObservable } from 'mobx';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { TypeId } from 'src_common/common/websocket2/type';
import { EventMarketParticipantsForm } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketParticipantsForm/EventMarketParticipantsForm';

export class MarketSettingsTabState {
    @observable public editParticipants: boolean = false;

    public constructor(
        private readonly props: MarketSettingsTabPropsType,
        private readonly appState: AppState
    ) {
        makeAutoObservable(this);
    }

    @action public toggleParticipantsModal = (): void => {
        this.editParticipants = !this.editParticipants;
    };

    @action public onAddSelection = (): void => {
        const { marketId } = this.props;
        if (marketId === null) {
            return;
        }
        const marketModel = this.appState.sdkStaff.models.getMarket(marketId);

        if (marketModel === null) {
            return;
        }
        this.appState.reduxAction.onCreateBlankSelection(marketModel.eventId, marketId, 'custom');
    };

    @action public onAddAllSelections = (eventId: number, marketId: number, participants: unknown): void => {
        if (participants !== undefined) {
            this.onAddAllSelectionsHandler(eventId, marketId, participants);
            return;
        }
        this.toggleParticipantsModal();
    };

    @action private onAddAllSelectionsHandler = (eventId: number, marketId: number, participants: unknown): void => {
        this.appState.reduxAction.onAdAllSelections(eventId, marketId, participants);
    };
}

export interface MarketSettingsTabPropsType {
    marketId: TypeId.MarketId | null;
}

export const MarketSettingsTab = observer('MarketSettingsTab', (props: MarketSettingsTabPropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new MarketSettingsTabState(props, appState));

    if (props.marketId === null) {
        return null;
    }
    const marketModel = appState.sdkStaff.models.getMarket(props.marketId);

    if (marketModel === null) {
        return null;
    }

    const eventModal = appState.sdkStaff.models.getEvent(marketModel.eventId);
    if (eventModal === null) {
        return null;
    }

    return (
        <div className='market-settings'>
            <Popup
                title='Participants'
                className='manage-market-participants-modal'
                priority={1000}
                active={state.editParticipants}
                onClose={state.toggleParticipantsModal}
            >
                {state.editParticipants ? (
                    <EventMarketParticipantsForm
                        marketId={marketModel.id}
                        marketSelections={marketModel.selections}
                        eventParticipants={eventModal.participants}
                        onAddAllSelections={state.onAddAllSelections}
                        onSubmit={state.toggleParticipantsModal}
                    />
                ) : null}
            </Popup>

            <MarketSettingsForm
                marketId={marketModel.id2}
                onAddSelection={state.onAddSelection}
                onAddAllSelections={state.onAddAllSelections}
            />
        </div>
    );
});
